// Usage.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function Usage() {
    return (
        <PageLayout title="Usage" subtitle="Usage overview">
            <div className="container flex col box-container">
                {/* <div className="box">Usage</div> */}
            </div>
        </PageLayout>   
    );
}

export default Usage;
